import { useMutation, useQueryClient } from '@tanstack/react-query'
import { UserGroup, UsersApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

export type UpdateUserGroupParams = {
  userGroupId: number
  userGroup: UserGroup
}

export const useMutationUpdateUserGroup = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: UpdateUserGroupParams) => {
      return await baseClient
        .getApi(UsersApi)
        .updateUserGroup({
          userGroupId: params.userGroupId,
          userGroup: params.userGroup,
        })
        .catch(handleHTTPError)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.userGroupsAll })
    },
  })
}
